import styled from "styled-components";
import { IOpenAiChatModelConfig } from "types/Chat";

const FormField = styled.div`
  margin-bottom: 16px;
`;

/**
 * What the admin form says about suggested questions. No model type's widget reads
 * `config.suggestedPrompts` any more (components/ChatWidget/chatWidget.helpers.ts), so an editor
 * would change nothing: the patient bot shows its two fixed questions (CLE-2811) and the Hospital
 * Staff Bot shows none (2026-10-29). One note per type instead.
 */
export function suggestedQuestionsNote(modelType?: string): string {
  return modelType === "ContractManagementBot"
    ? "The Hospital Staff Bot widget shows no suggested questions."
    : "The patient chatbot's suggested questions are fixed and cannot be changed here.";
}

/**
 * Strips `suggestedPrompts` from a config that is about to be saved on a Patient Chat Bot — e.g.
 * questions copied over from a Hospital Staff Bot. Every other type's config is returned untouched,
 * so a Hospital Staff Bot's stored questions are saved back verbatim.
 */
export function prepareModelConfig(
  modelType: string | undefined,
  config?: IOpenAiChatModelConfig
): IOpenAiChatModelConfig | undefined {
  if (!config || modelType !== "PatientChatBot") {
    return config;
  }

  const stripped = { ...config };
  delete stripped.suggestedPrompts;
  return stripped;
}

interface ISuggestedQuestionsFieldProps {
  modelType?: string;
}

/** The read-only note in place of a suggested-questions editor (suggestedQuestionsNote). */
export function SuggestedQuestionsField({
  modelType,
}: ISuggestedQuestionsFieldProps) {
  return (
    <FormField>
      <small className="text-muted" data-testid="suggestedQuestionsNote">
        {suggestedQuestionsNote(modelType)}
      </small>
    </FormField>
  );
}
